import { render, staticRenderFns } from "./ErrorInfoDBC.vue?vue&type=template&id=d156b384&scoped=true"
import script from "./ErrorInfoDBC.vue?vue&type=script&lang=js"
export * from "./ErrorInfoDBC.vue?vue&type=script&lang=js"
import style0 from "./ErrorInfoDBC.vue?vue&type=style&index=0&id=d156b384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d156b384",
  null
  
)

export default component.exports